<template>
  <a-modal 
    :visible="visible" 
    :title="title" 
    :width="800"
    @cancel="onCancel"
    @ok="onSave"
    cancelText="取消" okText="确认">
    <a-form :form="edit_item" class="breed-item-form">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="RF Id">
            <a-input v-model="edit_item.rf_id" placeholder="请输入RF Id"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="VId">
            <a-input v-model="edit_item.vid" placeholder="请输入VId"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="出口号">
            <a-input v-model="edit_item.export_tag" placeholder="请输入出口号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="性别">
            <a-select v-model="edit_item.gender" placeholder="请选择性别">
              <a-select-option key="1" :value="1">公</a-select-option>
              <a-select-option key="1" :value="0">母</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="出生日期">
            <a-date-picker 
              v-model="edit_item.birth_date"
              style="width: 100%"
              placeholder="请选择出生日期"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="死亡日期">
            <div class="death-date-wrapper">
              <a-date-picker 
                v-model="edit_item.died_at"
                style="flex: 1"
                placeholder="请选择死亡日期"
              ></a-date-picker>
              <a-button 
                v-if="edit_item.died_at && edit_item.id"
                type="link" 
                size="small"
                @click="openEventRecord"
                class="event-record-btn">
                事件记录
              </a-button>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
              
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="农场选择">
            <farm-select :default_id="edit_item.farm_id" @finish_select="on_farm_select"></farm-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否存栏">
            <a-select v-model="edit_item.is_kept" :disabled="edit_item.died_at" placeholder="请选择">
              <a-select-option key="1" :value="1">存栏</a-select-option>
              <a-select-option key="0" :value="0">非存栏</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="个体状态">
            <a-select v-model="edit_item.state" :disabled="edit_item.died_at" placeholder="请选择状态">
              <a-select-option key="null" :value="null">已入库</a-select-option>
              <a-select-option key="1" :value="1">候补</a-select-option>
              <a-select-option key="2" :value="2">可用</a-select-option>
              <a-select-option key="3" :value="3">不可用</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="GEBV">
            <a-input v-model="edit_item.gebv_volume" placeholder="请输入GEBV"></a-input>
          </a-form-item> 
        </a-col>
        <a-col :span="8">
          <a-form-item label="育种索引值">
            <a-input v-model="edit_item.breed_index" placeholder="请输入育种索引值"></a-input>
          </a-form-item> 
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="父代VId">
            <item-select 
              :gender="1" 
              placeholder="请输入或选择父代VId"
              @finish-select="(e) => {edit_item.item_father = e}"
              ref="father_select">
            </item-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="母代VId">
              <item-select 
              :gender="0" 
              placeholder="请输入或选择母代VId"
              @finish-select="(e) => {edit_item.item_mother = e}"
              ref="mother_select">
            </item-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 事件记录弹窗 -->
    <event-record-modal ref="eventRecordModal" @success="onEventRecordSuccess" />
  </a-modal>
</template>

<script>
import itemSelect from './itemSelect.vue';
import farmSelect from './../../farms/components/farmSelect.vue'
import eventRecordModal from './eventRecordModal.vue'
export default {
  name: "breedItemEdit",
  components: {
    itemSelect, farmSelect, eventRecordModal
  },
  data() {
    return {
      edit_item: {},
      action: '',
      edit_item_template: {
        id: '',
        vid: '',
        export_tag: '',
        state: null,
        father_id: null,
        mother_id: null,
        rf_id: '',
        gender: 0,
        item_mother: '',
        item_father: '',
        birth_date: '',
        died_at: null,
        gebv_volume: null,
        breed_index: '',
        color: 'White',
        breed_type_id: 2,
        is_kept: 0
      },
      visible: false,
      title: ''
    }
  },
  methods: {
    open(action, item) {
      this.action = action
      if (action == 'add') {
        this.title = '新增个体'
        this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
        // 支持预设父母信息
        if (item) {
          if (item.father_id) {
            this.edit_item.father_id = item.father_id
          }
          if (item.mother_id) {
            this.edit_item.mother_id = item.mother_id
          }
          if (item.item_father) {
            this.edit_item.item_father = item.item_father
          }
          if (item.item_mother) {
            this.edit_item.item_mother = item.item_mother
          }
          if (item.farm_id) {
            this.edit_item.farm_id = item.farm_id
          }
        }
        this.$nextTick(() => {
          this.$refs.father_select.onOpen(item?.item_father || '')
          this.$refs.mother_select.onOpen(item?.item_mother || '')
        })
      } else {
        this.title = '编辑个体'
        this.edit_item = item
        this.$nextTick(() => {
          this.$refs.father_select.onOpen(item.item_father)
          this.$refs.mother_select.onOpen(item.item_mother)
        })
      }
      this.visible = true
    },
    onCancel() {
      this.visible = false
    },
    onSave() {
      let payload = JSON.parse(JSON.stringify(this.edit_item_template))

      Object.keys(payload).forEach(key => {
        if (this.edit_item[key]) {
          payload[key] = this.edit_item[key]
        }
      })
     
      // 格式化日期为 YYYY-MM-DD 格式
      const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      if (payload.birth_date) {
        payload.birth_date = formatDate(payload.birth_date)
      }
      if (payload.died_at) {
        payload.died_at = formatDate(payload.died_at)
      }
      if (!payload.item_father && payload.father_id) {
        payload.father_id = null
      }
      if (!payload.item_mother && payload.mother_id) {
        payload.mother_id = null
      }
      if (this.action == 'add') {
        this.$api.post_breed_item(payload).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit', true)
          }
        })
      } else {
        this.$api.put_breed_item(payload.id, payload).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit', true)
          }
        })
      }
    },
    on_farm_select(farm_id) {
      this.edit_item.farm_id = farm_id
    },
    // 打开事件记录弹窗
    openEventRecord() {
      if (this.edit_item.id) {
        this.$refs.eventRecordModal.open(this.edit_item.id)
      }
    },
    // 事件记录创建成功回调
    onEventRecordSuccess() {
      this.$message.success('事件记录已创建')
    }
  },
}
</script>

<style scoped>
.breed-item-form .ant-form-item {
  margin-bottom: 16px;
}
.breed-item-form .ant-select {
  width: 100%;
}
.breed-item-form .ant-input {
  width: 100%;
}
.death-date-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.event-record-btn {
  padding: 0 8px;
  white-space: nowrap;
}
</style>